import { useState } from "react";

import { PiBugBeetleBold } from "react-icons/pi";

import { Button } from "@shared/components/ui/Button";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "@shared/components/ui/drawer";

import { DebugCardUser } from "./components/debug-card-user";
import { DebugCardImpersonate } from "./components/debug-card-impersonate";
import { DebugCardCrash } from "./components/debug-card-crash";
import { useSession } from "../auth/hooks/useSession";

export const DebugDrawer = () => {
  const { isAdmin } = useSession();

  const [forceDebugEnabled, setForceDebugEnabled] = useState(undefined);

  const isDebugEnabled = forceDebugEnabled ?? isAdmin;

  // @ts-expect-error window not typed
  window.toggleDebug = () => {
    setForceDebugEnabled(() => !isDebugEnabled);
  };

  // @ts-expect-error window not typed
  window.hideDebug = () => {
    setForceDebugEnabled(() => false);
  };

  // @ts-expect-error window not typed
  window.showDebug = () => {
    setForceDebugEnabled(() => true);
  };

  if (!isDebugEnabled) {
    return null;
  }

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button className="fixed right-24 bottom-[12px] z-fixed rounded-full !size-[46px] text invisible md:visible">
          <PiBugBeetleBold className="size-[20px] shrink-0" />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="p-10 grid grid-cols-2 gap-10">
        <DebugCardUser />
        <DebugCardImpersonate />
        <DebugCardCrash />
      </DrawerContent>
    </Drawer>
  );
};
